import type { FC } from 'react'
import AppLink from '@chegg-wt/core/components/AppLink'
import { AppRoute } from '@chegg-wt/core/types/core'
import { ActionButton, CardContainer, CardContent, CardHeading } from './styled'

export interface CarouselCardProps {
  isActive: boolean
  heading: JSX.Element | string
  content: string
  actionButtonRoute: AppRoute
  actionButtonText: string
  dataTestId?: string
  onClick?: () => void
}

export const CarouselCard: FC<CarouselCardProps> = ({
  isActive,
  actionButtonRoute,
  actionButtonText,
  content,
  heading,
  onClick,
  dataTestId,
}) => {
  return (
    <CardContainer isActive={isActive} onClick={onClick} data-test={dataTestId}>
      <CardHeading>{heading}</CardHeading>
      <CardContent>{content}</CardContent>
      <AppLink route={actionButtonRoute}>
        <ActionButton isCardActive={isActive} href="#">
          {actionButtonText}
        </ActionButton>
      </AppLink>
    </CardContainer>
  )
}
